import {View} from "@unibuddy/patron";

import {useIsDesktop} from "ubcommunity-shared/src/General/useIsDesktop/useIsDesktop";
import {MarketingConsent} from "ubcommunity-shared/src/MarketingConsent/MarketingConsent";

export const MarketingConsentPage = () => {
    const {isDesktop} = useIsDesktop();

    if (isDesktop) {
        return (
            <View flex="1" justifyContent="center" alignItems="center">
                <View maxW={400}>
                    <MarketingConsent />
                </View>
            </View>
        );
    }

    return <MarketingConsent />;
};
